import { Avatar } from '@material-ui/core'
import defaultAvatar from 'assets/img/default-avatar.png'
import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import { INativeDoctorProps } from 'data/doctor'

import './style.scss'

interface IProps extends INativeDoctorProps, RouteComponentProps {}

export class Doctor extends React.Component<IProps> {
  render() {
    const {
      doctorName,
      doctorPhoto,
      doctorProfession,
      doctorLocation,
      distance,
      hospitalName,
      onClick
    } = this.props
    return (
      <div className="doctor-wrapper" onClick={onClick}>
        <Avatar className="doctor-image" src={doctorPhoto || defaultAvatar} />
        <div className="doctor-information">
          <div className="doctor-name">Dr. {doctorName}</div>
          <div className="profession-hospital-name">
            {doctorProfession} - {hospitalName}
          </div>
          <div className="location-distance">
            {doctorLocation}{' '}
            <img
              className="point-img"
              src={require('../../assets/img/point.svg')}
            />
            {distance} mile
          </div>
        </div>
        <img
          className="button-img"
          src={require('../../assets/img/right-arrow.svg')}
        />
      </div>
    )
  }
}

const WithRouter = withRouter(Doctor)

export default (props: INativeDoctorProps) => <WithRouter {...props} />



// WEBPACK FOOTER //
// ./src/components/Doctor/index.tsx